/**
 * Vignette — adds a soft radial darkening around the edges of the screen.
 *
 * Decorative only. Aria-hidden. Sits at z-index 0 (below the star network
 * which sits at z-index 1, which sits below the game content at z-index 2+).
 *
 * See `docs/12_visual_art_bible.md` (warm darkness with intimate edges)
 * and `docs/16_random_sensory_effects.md` (atmospheric depth = canvas
 * for the random sensory effects to live on).
 */
import styles from './Vignette.module.css';

export function Vignette(): JSX.Element {
  return <div className={styles.vignette} aria-hidden />;
}
